import { API_HOST_NAME } from "../../constants.js"
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js"

const additionalActions = [
  { name: 'verify', member: true, method: 'POST' }
]

const useRegistryCredentialsResources = (teamId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/registry_credentials`
  return useAuthenticatedResources(url, {}, additionalActions)
}

export default useRegistryCredentialsResources
